module.exports = __webpack_public_path__ + "static/media/Pista_CabeloCastanho.9428fa93.png";